import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { Link } from 'react-router-dom';
import { saveUserImage } from 'containers/Profile-view/actions';
import styles from './User.scss';// to import local scss fle

const state = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington D.C',
  WN: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

class User extends Component {
  static propTypes = {
    fullname: PropTypes.string,
    state: PropTypes.string,
    city: PropTypes.string,
    school: PropTypes.string,
    year_of_graduation: PropTypes.string,
    saveUserImage: PropTypes.func.isRequired,
    profileId: PropTypes.string,
    profile_image: PropTypes.string,
    navBarUsedBy: PropTypes.string,
    instagram: PropTypes.string.isRequired,
    twitter: PropTypes.string.isRequired,
  };
  static defaultProps = {
    fullname: '',
    state: '',
    city: '',
    school: '',
    year_of_graduation: '',
    profileId: '',
    profile_image: PropTypes.string,
    navBarUsedBy: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      changeImage: false,
      userImage: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.onMouseHover = this.onMouseHover.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  onMouseHover() {
    this.setState({ changeImage: true });
  }
  onMouseOut() {
    this.setState({ changeImage: false });
  }
  handleChange(event) {
    const reader = new window.FileReader();
    const file = event.target.files[0];
    reader.onloadend = () => {
      this.setState({
        userImage: reader.result,
      });
    };
    reader.readAsDataURL(file);
    // this.setState({ userImage: image });
    this.props.saveUserImage(this.props.profileId, file);
  }


  render() {
    const renderChangeImage = renderIf(this.state.changeImage && !(this.props.navBarUsedBy === 'coach'));
    const renderChangeImageForm = renderIf(this.props.navBarUsedBy === 'athlete');
    const renderTwitterIcon = renderIf(this.props.twitter !== '');
    const renderInstagramIcon = renderIf(this.props.instagram !== '');
    // console.log(this.props);
    return (
      <div className={cn('row', styles.userContainer)}>
        <span>
          <div className={cn('col s12', styles.profileInfo)}>
            <div
              className={styles.image} onMouseOver={this.onMouseHover}
              onMouseOut={this.onMouseOut}
            >
              {this.state.userImage !== '' ?
                <img
                  className={styles.image}
                  src={this.state.userImage}
                  alt="user_image"
                /> :
                <img
                  className={styles.image}
                  src={this.props.profile_image !== '' ?
                          `https://s3.amazonaws.com/myrbimages/${this.props.profile_image}` :
                          'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png'}
                  alt="profile"
                />
              }
              {renderChangeImage(
                <div className={styles.changeImage}>
                  <div className={styles.changeImageText}>
                      change image.
                  </div>
                </div>,
                )}
              {renderChangeImageForm(
                <form>
                  <input
                    className={styles.fileInput}
                    type="file"
                    ref="file" //eslint-disable-line
                    name="myImage"
                    accept=".jpg,.jpeg"
                    onChange={this.handleChange}
                  />
                </form>,
                )}
            </div>
            <div className={styles.description}>
              <p className={styles.playerName}>{this.props.fullname}</p>
              <p className={styles.location}><spann>{this.props.city}</spann>,
                  &nbsp;{state[this.props.state]}</p>
              <p className={styles.location}>{this.props.school}<br />
                {this.props.year_of_graduation}
              </p>
              {/* eslint-disable*/}
              {renderTwitterIcon(
                <a className={styles.twitterIcon} target="_blank" href={this.props.twitter}>
                  <img src="https://media.dev.myrecruitboard.com/Images/twitterForProfile.png" alt="twitter_icon" />
                </a>,
                )}
              {renderInstagramIcon(
                <a className={styles.instaIcon} target="_blank" href={this.props.instagram}>
                  <img src="https://media.dev.myrecruitboard.com/Images/instaForProfile.png" alt="twitter_icon" />
                </a>,
                )}
              <Link to={`/athlete/${this.props.profileId}`} target="_blank">
                <img className={styles.shareIcon} src="https://media.dev.myrecruitboard.com/Images/share-icon.png" alt="share-icon" title="Go to public profile" />
              </Link>
                {/* eslint-enable*/}
            </div>

          </div>
        </span>
      </div>);
  }
}

export default connect(null, {
  saveUserImage,
})(User);




// WEBPACK FOOTER //
// ./src/components/User/User.js